import React from 'react';

import { Checkbox } from '@mui/material';
import PropTypes from 'prop-types';

import CheckBoxSvg from 'components/SvgComponents/icons/CheckBox';
import CheckUndefined from 'components/SvgComponents/icons/CheckUndefined';
import UnCheckBoxSvg from 'components/SvgComponents/icons/UnCheckBox';

const CheckBox = ({ checkedIcon, icon, size = 16, ...props }) => (
  <Checkbox
    checkedIcon={checkedIcon || <CheckBoxSvg width={size} height={size} />}
    icon={icon || <UnCheckBoxSvg width={size} height={size} />}
    indeterminateIcon={<CheckUndefined width={size} height={size} />}
    {...props}
  />
);

CheckBox.propTypes = {
  icon: PropTypes.node,
  checkedIcon: PropTypes.node,
  size: PropTypes.number,
};

export default CheckBox;
